/*
  A creator submission that is the same post as a detected mention is excluded from counting
  with this note. A later brand or creator rejection through /mark_invalid overwrites the note,
  which is how the stats run and the UI tell a matched duplicate from a rejection without a
  separate column: the duplicate reading holds only while the note is still ours.
*/

const getDuplicateMentionExclusionNote = canonicalMentionId => `Same post as automatically detected mention ${canonicalMentionId}`;

const isDuplicateMentionExclusion = expectation =>
  !!expectation?.hasBeenMarkedInvalid &&
  !!expectation.mention?.CanonicalMention_id &&
  expectation.markedInvalidNote === getDuplicateMentionExclusionNote(expectation.mention.CanonicalMention_id);

module.exports = {
  getDuplicateMentionExclusionNote,
  isDuplicateMentionExclusion
};
